export default "__VITE_ASSET__1232d0ad__"